var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMarketHome(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "24px",
    height: "24px",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "art/icons/product/domain-buynow",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7.69058298,6.32665644 C7.67472925,6.54904022 7.66666667,6.77357855 7.66666667,7 C7.66666667,12.1546577 11.8453423,16.3333333 17,16.3333333 C18.4316536,16.3333333 19.7880206,16.0109928 21.0004841,15.4349284 L21.0000416,21.0006332 C21.0000416,21.513469 20.6139835,21.9361403 20.1166423,21.9939054 L20.0000208,22.0006332 L14.0000208,22.0006332 L14.0000208,16.0006332 L10.0000208,16.0006332 L10.0000208,22.0006332 L4.00002082,22.0006332 C3.48718498,22.0006332 3.06449571,21.614593 3.00672803,21.1172543 L3,21.0006332 L3,12.1106332 C2.99861901,11.8832523 3.06769037,11.6622015 3.19600936,11.477125 L3.28002082,11.3706332 L7.69058298,6.32665644 Z M17,0 C18.8565154,0 20.6369928,0.737497883 21.9497475,2.05025253 C23.2625021,3.36300718 24,5.14348457 24,7 C24,10.8659932 20.8659932,14 17,14 C13.1340068,14 10,10.8659932 10,7 C10,3.13400675 13.1340068,0 17,0 Z M17,2.2 C14.3490332,2.2 12.2,4.3490332 12.2,7 C12.2,9.6509668 14.3490332,11.8 17,11.8 C18.2730392,11.8 19.4939379,11.2942872 20.3941125,10.3941125 C21.2942872,9.49393793 21.8,8.27303915 21.8,7 C21.8,4.3490332 19.6509668,2.2 17,2.2 Z M17,4 C18.6568542,4 20,5.34314575 20,7 C20,7.79564947 19.6839295,8.55871121 19.1213203,9.12132034 C18.5587112,9.68392948 17.7956495,10 17,10 C15.3431458,10 14,8.65685425 14,7 C14,5.34314575 15.3431458,4 17,4 Z M17,6 C16.4477153,6 16,6.44771525 16,7 C16,7.55228475 16.4477153,8 17,8 C17.2652165,8 17.5195704,7.89464316 17.7071068,7.70710678 C17.8946432,7.5195704 18,7.26521649 18,7 C18,6.44771525 17.5522847,6 17,6 Z",
    id: "Mask",
    fill: "currentColor",
    fillRule: "nonzero"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMarketHome);
export default __webpack_public_path__ + "static/media/market-home.08ad024c6981d8674e1d1a9ad63234b2.svg";
export { ForwardRef as ReactComponent };